"use client";

import { useTranslations } from "next-intl";

const NAMESPACE = "new-sls-selective-laser-sintering";

export default function WhatIsSls() {
	const t = useTranslations(NAMESPACE);

	return (
		<section className="bg-white py-8 sm:py-10 md:py-12 lg:py-16">
			<div className="container">
				<div className="grid items-center gap-6 md:gap-10 lg:grid-cols-[minmax(0,1fr)_minmax(0,1.6fr)] lg:gap-16">
					<h2 className="whitespace-pre-line text-2xl font-bold leading-tight text-black sm:text-[30px] md:text-4xl">
						{t("whatIsSlsTitle")}
					</h2>
					<div className="space-y-4 text-sm leading-relaxed text-black md:text-base">
						<p>{t("whatIsSlsDesc1")}</p>
						<p>{t("whatIsSlsDesc2")}</p>
					</div>
				</div>
			</div>
		</section>
	);
}
